// AT-1413: een <details data-dismissable> (het servicemenu in de header) sluit bij een klik
// ernaast, bij Escape en zodra er een item gekozen is. Een <details> doet dat zelf niet:
// die blijft open tot je opnieuw op de knop klikt. Luistert op document, zodat het ook
// werkt voor markup die Turbo of red-legacy.js later vervangt.
function closeAll(except) {
  document.querySelectorAll('details[data-dismissable][open]').forEach(function (el) {
    if (el !== except) el.removeAttribute('open');
  });
}

document.addEventListener('click', function (event) {
  var menu = event.target.closest('details[data-dismissable]');
  // Klik op een item in het menu: het menu mag dicht, de link of modal doet de rest.
  if (menu && event.target.closest('a')) {
    menu.removeAttribute('open');
    return;
  }
  closeAll(menu);
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  var open = document.querySelector('details[data-dismissable][open]');
  if (!open) return;
  open.removeAttribute('open');
  var summary = open.querySelector('summary');
  if (summary) summary.focus();
});
